export default "__VITE_ASSET__ee99086b__"